/*
 * @Author: your name
 * @Date: 2021-08-13 17:28:14
 * @LastEditTime: 2021-08-23 13:48:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \EMS_h5_mall\src\api\config.js
 */
/**
 * 地址配置
 */
// 测试服
//  const testUrl = 'http://192.168.1.71/iot-service/',port = "80"
//  const url = 'http://192.168.1.71/iot-service/'

// 生产
 const testUrl = 'http://192.168.1.71/iot-service/',port = "80"
 const url = 'https://www.signalsupervisor.com/iot-service/' // web后台接口地址

// 王文宇的本地
// const testUrl = "http://192.168.3.141:1806/", port = "80";
// const url = "http://39.108.141.75/api-cms/";


let httpUrl=''  //用来拼接协议文件
let baseUrl = "";

if (process.env.NODE_ENV === "development") {
  //测试
  baseUrl = testUrl;
} else if (process.env.NODE_ENV === "production") {
  //生产
  baseUrl = url;
}
if(baseUrl == 'http://192.168.1.71/iot-service/' || baseUrl == 'http://192.168.3.141:1806/'){
  httpUrl= 'http://192.168.1.71:7115/'
}else{
  httpUrl = 'http://h5.signalsupervisor.com/'
}
// export { baseUrl };
export { baseUrl, port , httpUrl};
